module.exports = __webpack_public_path__ + "img/logoLight.fabd096e.png";